import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const InfoSpotV2 = ({
  spotFillColor = '#515354',
  spotHeight = '24',
  spotViewBox = '0 0 24 24',
  spotWidth = '24',
  ...svgProps
}: IconProps = {}): React.ReactElement => (
  <svg
    width={spotWidth}
    height={spotHeight}
    viewBox={spotViewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M21.8601 10.3101C21.1801 6.17011 17.8401 2.82011 13.6901 2.14011C6.85011 1.02011 1.02011 6.85011 2.14011 13.6901C2.82011 17.8301 6.16011 21.1801 10.3101 21.8601C17.1501 22.9801 22.9801 17.1501 21.8601 10.3101ZM13.0501 17.0701C13.0501 17.3101 12.8601 17.5001 12.6201 17.5001H11.3901C11.1501 17.5001 10.9601 17.3101 10.9601 17.0701V10.7901C10.9601 10.5701 11.1201 10.3901 11.3301 10.3601L12.5601 10.1901C12.8201 10.1501 13.0501 10.3601 13.0501 10.6201V17.0701ZM11.9901 8.88011C11.2701 8.88011 10.7801 8.36011 10.7801 7.70011C10.7801 7.04011 11.2701 6.50011 11.9901 6.50011C12.7201 6.50011 13.2101 7.03011 13.2101 7.70011C13.2201 8.36011 12.7201 8.88011 11.9901 8.88011Z"
      fill={spotFillColor}
    />
  </svg>
);
